module.exports = __webpack_public_path__ + "0dd4be1ab62aa566ad1845a51340526b.pdf";